import React from "react";
import "./FAQs.css";

const FAQs = () => {
  return (
    <div className="questions-section">
      <div className="title">FAQs</div>

      <div className="question-list">
        {/* <div className="question">
          <div className="question-title">Is it free?</div>
          <div className="question-answer">
            The app costs a one-time payment of $1.99. There are no
            subscriptions. You pay once and get full access.
          </div>
        </div> */}

        <div className="question">
          <div className="question-title">Will I see ads in the app?</div>
          <div className="question-answer">
            No. The app is completely ad-free, so you can stay focused without
            distractions.
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQs;
